import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../service/auth/auth.service';
import { environment } from '../../environments/environment';

/**
 * Interceptor que añade el token de autenticación a las peticiones HTTP
 */
export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const clientId = environment.appName || 'autenicworkshop';
  const token = authService.getToken();

  // Agregar el x-client-id header a todas las peticiones
  let headers: Record<string, string> = {
    'x-client-id': clientId,
  };

  if (token) {
    headers = {
      ...headers,
      Authorization: `Bearer ${token}`,
    };
  }

  let modifiedRequest = req.clone({
    setHeaders: headers,
  });

  return next(modifiedRequest);
};
